import { Currency } from '@principle-theorem/accounting';
import {
  DepositPaymentMode,
  DepositRequestStatus,
  type IDepositRequest,
  type IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock, MockTimestamp } from '@principle-theorem/shared';
import { MockDocRef } from '@principle-theorem/testing';

export class DepositRequestMock extends BaseFirestoreMock<IDepositRequest> {
  practiceRef = MockDocRef<IPractice>();
  treatmentName = 'Check-up';
  amountCents = 5000;
  currency: Currency = Currency.AUD;
  paymentMode = DepositPaymentMode.Charge;
  status = DepositRequestStatus.Pending;
  expiresAt = MockTimestamp();
}
